module.exports = __webpack_public_path__ + "static/optimizely2-af132cc4d0a210c8f01eb618df9a8e46.png";